export function InternalServerErrorPageView() {
  return (
    <div>
      <h1>Error 500</h1>
      <p>Internal Server Error</p>
    </div>
  );
}
